import React from 'react';
import ModDashboard from './ModDashboard'; // Sicherstellen, dass der Dateiname stimmt

function App() {
  return <ModDashboard />;
}

export default App;

